module.exports = __webpack_public_path__ + "assets/flags/it.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/it.svg
// module id = 504
// module chunks = 0